import {
  AddressValidationResponse,
  ADDRESS_RESULT_STATUS,
  VALIDATION_RESULTS,
  VERIFICATION_STATUS,
  AddressValidationResult,
} from 'typescript/types/api/address_validation';
import { VALIDATION_STATUS } from 'typescript/utilities/address_validation';

const defaults = {
  original_address: {
    service_name: null,
    token: null,
    first_name: 'John',
    last_name: 'Cena',
    name: 'John Cena',
    company: '',
    phone: '(123) 456-7890',
    address_line_1: '1955 Broadway',
    address_line_2: '',
    locality: 'Oakland',
    administrative_district_level_1: 'CA',
    postal_code: '94612',
    country_code: 'US',
  },
  corrected_address: {
    service_name: 'square_address_service',
    token: null,
    first_name: 'John',
    last_name: 'Cena',
    name: 'John Cena',
    company: '',
    phone: '(123) 456-7890',
    address_line_1: '1955 Broadway',
    address_line_2: '',
    locality: 'Oakland',
    administrative_district_level_1: 'CA',
    postal_code: '94612-2205',
    country_code: 'US',
  },
  changed_fields: [],
};

const getResultAndStatuses = (status: VALIDATION_STATUS) => {
  switch (status) {
    case VALIDATION_STATUS.VERIFIED: {
      return {
        result: VALIDATION_RESULTS.VALIDATED,
        address_service_statuses: {
          status: ADDRESS_RESULT_STATUS.SUCCESS,
          verification_status: VERIFICATION_STATUS.VERIFIED,
        },
      };
    }
    case VALIDATION_STATUS.PARTIALLY_VERIFIED: {
      return {
        result: VALIDATION_RESULTS.FAILED,
        address_service_statuses: {
          status: ADDRESS_RESULT_STATUS.FAILED_VERIFICATION,
          verification_status: VERIFICATION_STATUS.PARTIALLY_VERIFIED,
        },
      };
    }
    case VALIDATION_STATUS.FAILED_VERIFICATION: {
      return {
        result: VALIDATION_RESULTS.VALIDATED,
        address_service_statuses: {
          status: ADDRESS_RESULT_STATUS.FAILED_VERIFICATION,
          verification_status: VERIFICATION_STATUS.VERIFY_FAILED,
        },
      };
    }
    default: {
      return {
        result: VALIDATION_RESULTS.VALIDATED,
        address_service_statuses: {
          status: ADDRESS_RESULT_STATUS.SUCCESS,
          verification_status: VERIFICATION_STATUS.VERIFIED,
        },
      };
    }
  }
};

export const addressValidationResponseFixture = (
  status: VALIDATION_STATUS,
): AddressValidationResponse => {
  const resultAndStatuses = getResultAndStatuses(status);

  return {
    address_validation_result: {
      ...defaults,
      ...resultAndStatuses,
    },
  };
};

export const addressValidationResultFixture = (
  status: VALIDATION_STATUS = VALIDATION_STATUS.PARTIALLY_VERIFIED,
): AddressValidationResult => {
  const responseFixture = addressValidationResponseFixture(status);

  return responseFixture.address_validation_result;
};
